/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Coinvestments_Report_Financialreturns_Asof3Inputs */

const en_coinvestments_report_financialreturns_asof3 = /** @type {(inputs: Coinvestments_Report_Financialreturns_Asof3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As of ${i?.period}`)
};

/**
* | output |
* | --- |
* | "As of {period}" |
*
* @param {Coinvestments_Report_Financialreturns_Asof3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_financialreturns_asof3 = /** @type {((inputs: Coinvestments_Report_Financialreturns_Asof3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Financialreturns_Asof3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_financialreturns_asof3(inputs)
});
export { coinvestments_report_financialreturns_asof3 as "coInvestments_report_financialReturns_asOf" }